<template>
  <el-dialog :title="$t('labelManage.addTitle')" :visible.sync="dialogVisible" width="50%" @close="handleClose">
    <el-form ref="addForm" :model="addLabelInfo" :rules="rules" label-width="120px">
      <el-form-item :label="$t('labelManage.labelName')" prop="labelName">
        <el-input v-model="addLabelInfo.labelName" :placeholder="$t('labelManage.labelNamePlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('labelManage.domain')" prop="domain">
        <el-select v-model="addLabelInfo.domain" :placeholder="$t('labelManage.domainPlaceholder')" style="width:100%">
          <el-option v-for="item in addLabelInfo.domains" :key="item.statusCd" :label="item.name"
            :value="item.statusCd" />
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="saveLabelInfo">
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { saveLabel } from '@/api/goods/labelApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AddLabel',
  data() {
    return {
      dialogVisible: false,
      addLabelInfo: {
        labelName: '',
        domains: [],
        domain: '',
        labelType: 'C',
        shopId: ''
      },
      rules: {
        labelName: [
          { required: true, message: this.$t('labelManage.labelNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('labelManage.labelNameMaxLength'), trigger: 'blur' }
        ],
        domain: [
          { required: true, message: this.$t('labelManage.domainRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.getDomains()
    },
    async getDomains() {
      try {
        const { data } = await getDict('s_label', 'domain')
        this.addLabelInfo.domains = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleClose() {
      this.$refs.addForm.resetFields()
      this.addLabelInfo = {
        labelName: '',
        domains: [],
        domain: '',
        labelType: 'C',
        shopId: ''
      }
    },
    async saveLabelInfo() {
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          let shopId = getShopId()
          this.addLabelInfo.shopId = shopId
          try {
            await saveLabel(this.addLabelInfo)
            this.$message.success(this.$t('common.submitSuccess'))
            this.dialogVisible = false
            this.$emit('refresh')
          } catch (error) {
            this.$message.error(error)
            console.error('添加标签失败:', error)
          }
        }
      })
    }
  }
}
</script>